import { forwardRef, ReactNode, MouseEvent, useImperativeHandle, useRef, RefObject } from 'react'

import { useOnClickOutside } from '@App/hooks'

export const OutsideClickComponent = forwardRef<
  HTMLDivElement,
  {
    children: ReactNode
    handler: (e: MouseEvent | Event) => void
    className?: string
    onClick?: (e: MouseEvent<HTMLDivElement>) => void
    onMouseDown?: (e: MouseEvent<HTMLDivElement>) => void
    excludeRefs?: Array<RefObject<HTMLElement | null>>
  }
>(({ children, handler, className, onClick, onMouseDown, excludeRefs }, forwardedRef) => {
  const innerRef = useRef<HTMLDivElement>(null)

  useImperativeHandle(forwardedRef, () => innerRef.current as HTMLDivElement)

  useOnClickOutside(innerRef, handler, excludeRefs)

  return (
    <div ref={innerRef} className={className} onClick={onClick} onPointerDown={onMouseDown}>
      {children}
    </div>
  )
})

OutsideClickComponent.displayName = 'OutsideClickComponent'
export default OutsideClickComponent
